import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";

const ScatterJitterPlot = () => {
  const [chartVariation, setChartVariation] = useState("variation1");

  // Your existing rawData object
  const rawData = {
    99283: [
      1209.0, 66.87, 94.4, 49.17, 82.02, 1000.0, 2124.0, 3630.0, 323.08, 912.0,
      3572.73, 773.0, 1154.0, 752.0, 234.63, 1773.0, 2263.0, 1309.0, 2017.0,
      2323.0, 1838.0, 408.0, 2268.0, 1574.0, 559.0, 1314.0, 671.0, 200.78,
      2123.0, 1153.0, 2072.0, 1548.0, 1699.0, 1977.0, 2038.3, 2141.0, 750.0,
      1380.0, 2050.0, 1602.0, 2921.0, 1397.0, 534.16, 629.0, 3255.0, 482.0,
      1220.0, 5230.0, 1536.0, 2325.0, 1767.0, 1567.0, 1761.0, 1148.0, 1455.0,
      2779.0, 3790.0, 1611.0, 704.0, 248.0, 158.0, 166.0, 3554.0, 2658.0,
      2907.68, 1642.34, 1400.0, 1538.0, 3069.0, 2609.0, 2567.0, 1045.0, 425.0,
      1268.43, 2309.0, 2116.0, 1712.0, 806.0, 1957.0, 1542.0, 2236.0, 2055.0,
      1070.0, 3135.0, 615.4, 289.69, 168.45, 138.31, 267.49, 219.04, 233.69,
      323.95, 1067.0, 1315.0, 443.83, 645.31, 94.3, 740.0, 863.0, 540.0, 1080.0,
      1869.0, 2228.0, 110.94, 1322.0, 3140.0, 394.0, 2096.0, 3795.0, 6550.0,
      522.0, 2750.0, 525.0, 756.0, 1704.0, 1975.0, 1686.0, 380.33, 788.0,
      1788.4, 1640.0, 2200.0, 1834.0, 725.0, 853.61, 1918.44, 529.0, 1155.0,
      2249.0, 837.0, 2625.0, 2844.0, 2418.0, 2626.0, 711.0, 2840.0, 5228.0,
      5895.0, 2357.0, 2713.0, 1302.0, 1915.0, 2660.0, 1423.0, 1470.0, 1630.0,
      230.28, 2647.0, 209.86, 2049.3, 1097.0, 2929.0, 202.5, 245.75, 266.21,
      238.89, 696.0, 1092.0, 2388.0, 10836.0, 2272.0, 2316.0, 3706.68, 4099.0,
      1729.0, 1874.0, 1808.0, 1647.0, 1750.0, 1250.0, 1749.0, 1040.0, 567.0,
      7129.0, 775.0, 176.68, 1897.0, 1543.0, 1787.0, 975.0, 1836.0, 1291.0,
      2082.0, 2512.0, 801.74, 921.0, 1195.0, 1516.0, 1414.47, 2426.0, 2137.0,
      1271.0, 1790.0, 2355.0, 1505.0, 2456.0, 4060.0, 1764.0, 906.0, 1824.82,
      1021.0, 1800.0, 1320.0, 2952.0, 1261.0, 630.0, 2241.0, 1122.0, 49999.5,
      850.0, 729.0, 1175.0, 2070.0, 2494.0, 1267.0, 1255.0, 905.0, 1391.0,
      2199.0, 1218.0, 168.37, 137.95, 173.91, 574.68, 194.83, 1025.0, 2640.0,
      702.0, 497.0, 822.0, 1890.0, 801.0, 519.0, 919.0, 2600.0, 1100.0, 2795.0,
      4400.0, 1194.57, 3495.0, 1084.0, 6062.0, 333.0, 1722.0, 2650.0, 656.0,
      3000.0, 707.26, 1607.0, 2172.57, 3036.0, 734.0, 2104.0, 1544.0, 1328.0,
      1760.0, 500.0, 9618.0, 2186.0, 1489.0, 1812.0, 1954.0, 2058.0, 2337.0,
      3164.0, 2195.0, 1194.0, 1517.0, 1236.01, 1623.0, 784.38, 959.69, 1552.0,
      1313.0, 344.98, 796.0, 575.0, 1200.0, 5809.0, 3657.0, 3991.0, 1256.0,
      2839.0, 1139.0, 405.0, 3983.0, 965.0, 3147.0, 1713.0, 1026.0, 330.0,
      1593.0, 1495.0, 1317.0, 992.0, 1479.0, 7.87, 889.0, 279.91, 206.91, 987.0,
      625.0, 1311.0, 730.0, 1539.0, 3874.0, 3218.0, 1556.0, 1782.0, 3139.0,
      1560.0, 439.0, 1030.0, 1107.0, 1858.5, 876.0, 2080.0, 1446.0, 1938.0,
      1575.05, 2007.0, 1683.0, 2033.0, 5582.0, 1342.0, 370.0, 2481.0, 1639.0,
      3100.0, 1829.0, 4534.0, 875.0, 1416.0, 2654.0, 1087.0, 1043.0, 1086.0,
      866.0, 979.0, 602.0, 1867.0, 1207.0, 4738.0, 835.0, 233.0, 1948.0, 1581.0,
      1300.0, 339.0, 2353.84, 878.0, 1920.0, 815.0, 1680.0, 1406.0, 1128.0,
      2509.0, 1330.0, 2225.0, 880.0, 428.0, 475.0, 1124.0, 1235.0, 1766.0,
      1351.0, 2763.0, 563.0, 1500.0, 2943.0, 2423.0, 550.0, 2458.0, 2662.0,
      2381.0, 5601.96, 5194.0, 2969.91, 153.06, 240.82, 265.28, 212.42, 200.0,
      120.0, 957.0, 286.0, 2969.0, 924.0, 2724.0, 1208.0, 661.0, 1061.0, 2163.0,
      1835.0, 1044.0, 913.0, 1236.0, 465.0, 3891.0, 708.0, 362.0, 4461.0,
      2562.0, 1020.0, 2910.0, 4070.0, 2326.0, 2582.0, 3266.0, 929.0, 1278.0,
      1728.0, 1833.0, 1259.0, 1104.96, 2089.21, 504.01, 1911.0, 1944.0, 1885.0,
      2365.0, 378.0, 1213.0, 3386.0, 2318.0, 598.0, 1868.0, 733.0, 2661.0,
      3200.0, 1693.0, 1439.0, 1136.0, 3616.0, 418.19, 574.0, 904.0, 1434.0,
      428.71, 1260.0, 1863.0, 1401.0, 2154.75, 984.0, 1893.0, 1116.0, 1600.0,
      70.8, 1167.0, 800.0, 1475.0, 1245.0, 1125.0, 1853.0, 1231.0, 471.0, 326.0,
      3012.0, 2769.22, 909.0, 818.0, 1098.0, 2160.0, 1009.0, 1477.0, 2182.0,
      710.0, 472.0, 888.0, 783.0, 530.0, 3051.0, 1277.0, 949.0, 1902.0, 2315.0,
      3031.0, 125.0, 805.0, 780.0, 2311.0, 2464.0, 1734.0, 1159.0, 1449.0,
      2507.0, 2502.0, 3171.0, 2472.0, 339.7, 250.91, 133.97, 479.65, 191.52,
      917.0, 1133.0, 2000.0, 1232.0, 861.0, 2675.0, 300.0, 1226.0, 2900.0,
      3531.0, 4487.0, 206.47, 1912.0, 3333.0, 2015.0, 2059.0, 2500.0, 894.0,
      590.0, 562.0, 1150.0, 1465.0, 1967.0, 1523.0, 1789.0, 1258.0, 1598.0,
      2715.0, 1996.0, 600.0, 950.0, 2962.0, 1438.96, 1322.57, 1214.0, 1088.0,
      4205.0, 794.0, 993.0, 638.0, 860.0, 400.0, 853.0, 596.0, 1586.0, 2364.0,
      2627.0, 2389.0, 1273.0, 131.88, 640.0, 10775.0, 3095.0, 364.7, 1484.0,
      1638.0, 450.0, 2677.0, 1012.2, 1591.0, 2550.0, 763.34, 1732.0, 1855.0,
      456.0, 1606.94, 2902.0, 1705.0, 819.0, 782.0, 6180.0, 732.0, 712.0,
      2118.0, 1540.0, 1056.0, 1173.0, 289.56, 2096.73, 1730.0, 2232.0, 2188.0,
      703.0, 2785.0, 4876.0, 1790.72, 1202.08, 5955.0, 6224.0, 6584.0, 1583.55,
      1047.0, 804.0, 842.78,
    ],
    74177: [
      570.56, 348.22, 539.79, 529.41, 725.0, 575.0, 960.99, 419.62, 1161.17,
      1322.59, 567.03, 550.51, 1046.42, 949.46, 531.3, 673.78, 270.27, 526.49,
      1129.1, 540.75, 1082.0, 820.32, 392.0, 252.0, 597.0, 1244.73, 1297.0,
      872.0, 987.61, 988.48, 506.86, 2266.35, 2715.34, 1185.55, 1368.77,
      1104.18, 821.74, 795.94, 653.51, 1253.46, 1530.67, 3788.71, 459.92,
      1134.67, 458.18, 1191.33, 883.02, 969.71, 509.8, 1078.14, 453.77, 659.16,
      426.12, 276.18, 854.7, 239.0, 1863.75, 670.78, 390.0, 685.87, 466.97,
      551.92, 1088.16, 1901.29, 1128.62, 1267.93, 680.57, 1487.0, 6162.0,
      830.02, 931.3, 943.79, 961.0, 2427.99, 264.25, 34.82, 313.4, 217.64,
      1173.0, 1097.0, 1070.25, 827.95, 1605.08, 956.8, 351.0, 948.48, 958.71,
      877.57, 948.66, 468.79, 585.0, 809.49, 635.23, 1485.58, 769.62, 525.93,
      250.0, 856.0, 564.47, 1547.55, 1699.14, 1034.99, 1137.86, 1003.67, 920.57,
      1142.66, 591.71, 416.5, 2583.13, 1290.05, 412.99, 414.0, 559.34, 681.21,
      500.0, 338.89, 4241.64, 698.15, 2003.16, 1124.28, 2740.0, 600.0, 3048.0,
      310.72, 607.1, 660.95, 2070.84, 667.02, 476.72, 924.48, 432.36, 952.77,
      298.0, 358.7, 267.0, 463.0, 509.93, 1141.64, 2108.38, 2110.01, 800.0,
      888.61, 525.0, 938.96, 836.61, 949.78, 1120.8, 1923.54, 4907.56, 511.97,
      656.13, 529.91, 451.85, 410.26, 5449.0, 685.11, 1191.26, 975.57, 1027.15,
      417.86, 2006.81, 944.24, 879.43, 1206.0, 459.0, 1246.95, 977.65, 5398.0,
      930.14, 49999.5, 834.82, 843.62, 539.0, 748.83, 222.0, 684.98, 666.6,
      832.07, 5668.0, 1184.73, 556.59, 417.0, 810.49, 186.74, 1295.0, 1353.27,
      391.08, 1363.04, 733.89, 874.18, 653.08, 946.53, 3898.94, 547.74, 505.75,
      2149.39, 3329.0, 2524.0, 397.23, 258.3, 751.63, 1368.17, 1088.07, 406.52,
      490.22, 872.73, 888.98, 808.16, 1255.03, 616.93, 520.32, 600.37, 462.76,
      370.0, 541.0, 1536.26, 2474.58, 788.34, 688.84, 1626.39, 1040.77, 1522.7,
      316.26, 1000.0, 279.11, 683.55, 939.49, 624.48, 2128.0, 208.11, 381.0,
      723.21, 624.89, 426.06, 369.23, 1085.44, 675.21, 675.02, 829.78, 684.07,
      840.91, 945.23, 213.81, 503.51, 1347.54, 428.63, 484.24, 961.13, 1255.71,
      1111.27, 295.99, 1185.36, 1242.42, 518.2, 519.0, 596.0, 1067.77, 1467.0,
      1257.86, 1526.53, 1128.74, 1018.62, 390.7, 654.29, 671.25, 459.08,
      1628.97, 653.0, 619.33, 919.99, 552.82, 1807.57, 763.76, 435.67, 685.04,
      1263.88, 651.79, 632.99, 904.91, 724.78, 663.74, 669.88, 442.27, 691.51,
      237.29, 596.66, 350.0, 1063.73, 818.79, 706.63, 929.33, 566.44, 3138.0,
      1796.1, 1040.59, 496.14, 2163.0, 226.02, 1075.0, 486.48, 727.0, 1101.4,
      1384.14, 803.64, 674.62, 232.46, 400.0, 331.15, 468.0, 338.0, 770.09,
      408.24, 680.95, 660.0, 2541.11, 1282.9, 1850.0, 476.13, 795.53, 502.05,
      774.86, 931.56, 820.44, 367.7, 1108.6, 703.5, 491.1, 1005.01,
    ],
    27447: [
      50089.0, 1453.24, 915.0, 20921.27, 20119.33, 10500.0, 714.0, 655.0,
      3737.83, 5197.0, 9661.0, 12734.0, 13087.0, 15187.4, 10000.0, 16000.0,
      37385.0, 41647.0, 5233.2, 143.8, 2199.0, 2765.03, 12404.08, 20070.5,
      14921.05, 13806.0, 17045.0, 13905.0, 9241.0, 24000.0, 947.0, 10381.5,
      4532.69, 14200.0, 11000.0, 31698.0, 2000.0, 11157.5, 725.0, 1473.71,
      11736.0, 20323.0, 5836.35, 1222.27, 1294.17, 908.0, 11943.84, 12862.6,
      13292.0, 5843.0, 934.0, 12000.0, 995.0, 3627.0, 3191.76, 688.0, 20972.0,
      19500.0, 32210.0, 11219.0, 3459.74, 5230.9, 4160.01, 4238.5, 15000.0,
      21225.0, 52000.0, 28825.0, 1725.56, 898.73, 11284.0, 842.0, 8664.88,
      4315.49, 3837.3, 4792.34, 5852.19, 4350.37, 4221.57, 3729.88, 23175.0,
      41574.0, 5695.0, 18010.1, 875.0, 16721.38, 4809.15, 10814.0, 530.0,
      49999.5, 12519.34, 14728.63, 15465.06, 3041.53, 9616.11, 11270.0,
    ],
    66984: [
      843.0, 60.17, 376.08, 511.47, 2131.43, 1600.0, 9510.0, 7990.0, 4481.0,
      1256.23, 1928.39, 1376.0, 1563.0, 1232.71, 4336.0, 5442.0, 1174.0, 1697.0,
      1627.38, 1332.0, 1396.0, 6300.0, 1456.0, 4588.78, 1922.93, 1529.26,
      1345.1, 1104.4, 1625.0, 2455.0, 1403.3, 1325.0, 1465.0, 957.0, 1907.51,
      1344.16, 1873.53, 1686.32, 926.0, 9452.0, 9256.0, 1137.23, 1407.21,
      1422.0, 941.96, 925.0, 1873.0, 956.0, 1357.27, 3567.0, 3087.29, 1410.81,
      2043.05, 1742.87, 3409.18, 2123.32, 2160.0, 1445.81, 1345.19, 918.0,
      602.32, 2744.81, 1376.56, 1652.18, 1168.83, 1128.0, 9907.0, 6909.0,
      3819.0, 1197.0, 1770.64, 1051.0, 1107.0, 928.0, 4911.0, 1097.0, 15000.0,
      12450.0, 1633.95, 1346.0, 1086.0, 1137.2, 1069.72, 2592.9, 722.08, 541.56,
      1553.94, 7062.0, 5033.0, 7185.0, 1983.9, 6133.0, 1071.61, 1040.0, 2894.0,
      1124.09, 1366.32, 4829.0, 1119.22, 5217.0, 1347.0, 6132.62, 1603.19,
      995.0, 3245.0, 1002.0, 980.44, 2291.0, 2062.0, 49999.5, 1000.0, 1167.0,
      3830.01, 1388.7, 1101.5, 2353.27, 1673.49, 1344.4, 1222.18,
    ],
    70450: [
      121.54, 75.96, 103.31, 139.88, 161.47, 137.39, 211.9, 156.6, 539.0,
      386.87, 263.0, 151.15, 800.0, 175.1, 199.89, 459.0, 269.37, 205.68,
      220.23, 235.38, 782.24, 307.89, 220.75, 275.8, 539.49, 246.83, 84.21,
      119.13, 138.77, 1362.77, 140.03, 929.13, 117.28, 311.33, 459.92, 416.5,
      377.66, 199.58, 167.04, 1082.0, 49999.5, 234.07, 329.27, 516.74, 234.51,
      769.62, 942.47, 314.09, 219.7, 348.36, 304.75, 62.27, 756.65, 2128.0,
      347.0, 1633.01, 378.36, 183.99, 177.72, 154.02, 392.2, 331.19, 574.21,
      695.73, 338.63, 324.27, 381.16, 276.72, 281.31, 293.0, 310.3, 415.03,
      68.91, 68.4, 328.26, 307.79, 284.49, 306.1, 133.59, 224.17, 241.8, 326.15,
      367.78, 161.54, 220.83, 12.15, 244.12, 874.18, 725.0, 282.58, 505.59,
      125.34, 222.0, 76.0, 519.0, 221.59, 304.39, 701.78, 250.0, 188.47, 301.53,
      173.31, 304.05, 274.73, 205.45, 167.93, 208.7, 420.26, 183.55, 285.37,
      280.19, 309.61, 345.98, 164.63, 1075.0, 350.45, 339.33, 557.11, 459.06,
      561.84, 578.7, 275.0, 135.67, 455.25, 466.63, 251.02, 1623.74, 213.66,
      148.86, 299.7, 411.49, 786.63, 394.94, 359.23, 727.0, 498.8, 1469.71,
      689.64, 299.21, 269.46, 432.91, 327.41, 551.56, 1131.07, 218.83, 305.96,
      269.07, 222.1, 306.42, 660.0, 326.66, 239.0, 6162.0, 270.32, 409.85,
      548.74, 297.81, 640.01, 176.43, 179.89, 205.14, 306.33, 159.11, 2524.0,
      190.49, 200.02, 145.85, 1055.0, 595.14, 450.0, 363.16, 203.98, 199.16,
      239.95, 241.07, 265.18, 200.09, 220.63, 304.56, 702.33, 217.87, 414.12,
      169.62, 179.45, 1184.73, 168.32, 217.15, 576.88, 392.0, 400.0, 198.73,
      129.17, 143.52, 110.13, 188.99, 171.41, 442.27, 490.42, 500.0, 391.77,
      403.03, 83.84, 311.63, 306.0, 276.12, 1300.0, 475.09, 435.06, 438.68,
      276.26, 226.23, 506.76, 365.35, 206.9, 84.02, 223.4, 707.42, 158.02,
      297.53, 478.83, 209.5, 301.91, 221.76, 272.61, 218.89, 301.99, 110.6,
      280.22, 272.37, 169.85, 299.15, 91.42, 3138.0, 1065.0, 350.0, 307.48,
      406.27, 513.46, 2163.0, 2162.0, 3329.0, 93.05, 306.84, 176.7, 214.07,
      109.39, 66.31, 237.87, 309.23, 229.92, 255.63, 282.33, 79.11, 600.0,
      339.93, 575.0, 596.0, 533.0, 1173.0, 271.21, 187.19, 192.8, 142.95,
      150.91, 1231.0, 414.0, 176.21, 589.04, 136.11, 146.36, 118.06, 105.55,
      384.79, 338.61, 149.3, 1022.98, 391.08, 370.0, 132.36, 474.88, 1246.95,
      1467.0, 2069.0, 156.1, 332.1, 436.59, 529.84, 162.17, 193.48, 64.54,
      367.53, 289.76, 403.77, 540.75, 234.54, 168.01, 228.08, 128.19, 666.6,
      531.28, 319.52, 383.25, 285.22, 226.83, 854.7, 240.94, 610.26, 1313.5,
      525.0, 2554.51, 146.07, 269.5, 620.68, 183.65, 199.22, 140.79, 198.03,
      133.49, 691.89, 1000.0, 262.71, 135.12, 122.35, 269.0, 307.65, 382.67,
      541.0, 312.17, 813.51, 787.09, 129.92, 310.79, 674.0, 653.0, 430.96,
      338.0, 267.0, 2740.0, 2882.0, 328.42, 252.0, 298.0, 154.6,
    ],
  };

  const categories = Object.keys(rawData);

  // Light theme with different bubble types
  const variation1Config = {
    colors: [
      "#93C5FD", // Pastel blue
      "#6EE7B7", // Pastel green
      "#FCD34D", // Pastel amber
      "#C4B5FD", // Pastel purple
      "#FCA5A5", // Pastel red
      "#67E8F9", // Pastel cyan
    ],
    title: "Standard Circular Bubbles (Pastel color",
    markerType: "circle",
    markerRadius: 5,
    jitter: { x: 0.35, y: 0 },
    showLegend: false,
    tooltipStyle: "standard",
  };

  const variation2Config = {
    colors: [
      "#60A5FA", // Softer blue
      "#34D399", // Softer green
      "#FB923C",
      "#A78BFA", // Softer purple
      "#F87171", // Softer red
      "#22D3EE", // Softer cyan
    ],
    title: "Dynamic Sized Bubbles (Bright color palette)",
    markerType: "circle",
    markerRadius: (y) => {
      if (y === 0) return 2; // Reasonable minimum
      const normalizedValue = Math.log10(y) / 4; // Less aggressive scaling
      return Math.max(2, Math.min(3 + normalizedValue * 4, 8)); // Range: 2-8px
    },
    jitter: { x: 0.45, y: 0.2 }, // More scatter in both directions
    showLegend: false,
    tooltipStyle: "enhanced",
  };

  const variation3Config = {
    colors: [
      "#93C5FD", // Pastel blue
      "#6EE7B7", // Pastel green
      "#FCD34D", // Pastel amber
      "#C4B5FD", // Pastel purple
      "#FCA5A5", // Pastel red
      "#67E8F9", // Pastel cyan
    ],
    title: "Simple Tooltip Variation",
    fontFamily: "Roboto Flex",
    markerType: "circle",
    markerRadius: 5,
    jitter: { x: 0.35, y: 0 },
    showLegend: false,
    tooltipStyle: "simple",
  };

  useEffect(() => {
    const configs = {
      variation1: variation1Config,
      variation2: variation2Config,
      variation3: variation3Config,
    };

    const config = configs[chartVariation];

    const series = categories.map((cat, index) => {
      const yValues = rawData[cat];
      const seriesColor = config.colors[index % config.colors.length];

      const data = yValues.map((y) => {
        // For variation 2, calculate dynamic radius for each point
        if (chartVariation === "variation2") {
          return {
            x: index,
            y: y,
            marker: {
              radius: config.markerRadius(y),
            },
          };
        } else {
          // For variation 1 and 3, use uniform points
          return {
            x: index,
            y: y,
          };
        }
      });

      // Series configuration - remove radius from series level for variation 2
      const seriesConfig = {
        name: cat,
        data,
        color: seriesColor,
        marker: {
          symbol: config.markerType,
          fillColor: seriesColor,
          lineColor: "rgba(255, 255, 255, 0.8)",
          lineWidth: chartVariation === "variation1" ? 0.5 : 1, // Thinner stroke
          states: {
            hover: {
              enabled: true,
              lineColor: "#FFFFFF",
              lineWidth: chartVariation === "variation1" ? 2 : 3,
            },
          },
        },
      };

      // Only set fixed radius for variation 1 and 3
      if (chartVariation === "variation1" || chartVariation === "variation3") {
        seriesConfig.marker.radius = config.markerRadius;
      }

      return seriesConfig;
    });

    if (typeof Highcharts === "object" && Highcharts.chart) {
      Highcharts.chart("container", {
        chart: {
          type: "scatter",
          zoomType: "xy",
          height: 700,
          backgroundColor: "#FFFFFF",
          plotBackgroundColor: "rgba(255, 255, 255, 0.9)",
          style: {
            fontFamily: "'Inter', 'Segoe UI', sans-serif",
          },
          spacing: [40, 20, 40, 20],
          borderRadius: 8,
        },
        navigation: {
          buttonOptions: {
            enabled: false,
          },
        },
        credits: { enabled: false },
        legend: {
          enabled: false,
        },
        title: {
          text: `Negotiated Rates for Top 5 codes with Highest Medicare weights`,
          style: {
            color: "#1E293B",
            fontSize: "24px",
            fontWeight: "700",
            fontFamily: "'Roboto Flex', sans-serif",
          },
          margin: 30,
          align: "left",
        },
        subtitle: {
          text:
            chartVariation === "variation1"
              ? "Uniform sized bubbles with pastel color palette"
              : chartVariation === "variation2"
              ? "Dynamic bubble size with brighter color palette"
              : "Uniform buble size with application color palette and PRIZM style",
          style: {
            color: "#64748B",
            fontSize: "14px",
            fontWeight: "400",
          },
          align: "left",
        },
        xAxis: {
          categories: categories,
          title: {
            text: "Medical Billing Codes",
            style: {
              color: "#64748B",
              fontSize: "14px",
              fontWeight: "600",
            },
          },
          labels: {
            style: {
              color: "#64748B",
              fontSize: "12px",
              fontWeight: "500",
            },
          },
          gridLineColor: "#F1F5F9",
          gridLineWidth: 1,
          lineColor: "#E2E8F0",
          tickColor: "#E2E8F0",
        },
        yAxis: {
          type: "logarithmic",
          title: {
            text: "Negotiated Rate ($) - Log Scale ",
            style: {
              color: "#64748B",
              fontSize: "14px",
              fontWeight: "600",
              fontFamily: "Roboto Flex",
            },
          },
          min: 1,
          labels: {
            style: {
              color: "#64748B",
              fontSize: "12px",
              fontWeight: "500",
            },
          },
          gridLineColor: "#F8FAFC",
          gridLineWidth: 1,
          lineColor: "#E2E8F0",
          tickColor: "#E2E8F0",
        },
        plotOptions: {
          scatter: {
            jitter: config.jitter,
          },
        },
        tooltip: {
          useHTML: true,
          backgroundColor: "white",
          borderColor: "#A9A9A9",
          borderRadius: 7,
          style: { fontFamily: "'Roboto Flex'" },
          headerFormat:
            `<span style="font-size: 14px; font-weight: 600">{series.name}</span><br/>` +
            `<span style="color: #E96926;">─────</span><br/>`,
          pointFormatter: function () {
            return `
              <div>
                <div style="color: #64748B; font-size: 11px;">MEDICARE %</div>
                <div style="font-size: 16px; font-weight: 700;">
                  ${Highcharts.numberFormat(this.y, 2, ".", ",")}%
                </div>
        
              </div>
            `;
          },
        },
        series: series,
      });
    }
  }, [chartVariation, categories]);

  return (
    <div
      className="p-6 "
      style={{ borderRadius: "8px", width: "97%", margin: "auto" }}
    >
      <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-3">
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-gray-700">
            Variations :
          </span>
          <select
            value={chartVariation}
            onChange={(e) => setChartVariation(e.target.value)}
            className="p-2 border border-gray-200 rounded-1 mx-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-sm font-medium"
          >
            <option value="variation1">Uniform Sized Bubbles</option>
            <option value="variation2">Dynamic Bubble Size by Magnitude</option>
            <option value="variation3">PRIZM themed chart</option>
          </select>
        </div>
      </div>

      <div className="bg-white rounded-2 border border-gray-200">
        <div
          id="container"
          style={{
            width: "100%",
            height: "700px",
          }}
        />
      </div>
    </div>
  );
};

export default ScatterJitterPlot;
